<template>
  <div class="v-color-picker">
    <input ref="input" v-model="model" class="v-color-picker__input" type="color" />
    <VInput v-model="model" :maxlength="9" pattern="#[a-fA-F\d]*" v-bind="$props">
      <template #suffix>
        <div class="v-color-picker__icon" :style="{ backgroundColor: model ?? undefined, background: model ?? undefined }" @click="input?.click()" />
      </template>
    </VInput>
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'

import VInput, { type Props } from './VInput.vue'

defineProps<Props>()

const model = defineModel<string | null>()

const input = useTemplateRef('input')
</script>

<style>
.v-color-picker {
  position: relative;
}

.v-color-picker__input {
  visibility: hidden;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
}

.v-color-picker__icon {
  cursor: pointer;
  width: 22px;
  pointer-events: auto;
  height: 22px;
  border-radius: 22px;
  margin: -1px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
    conic-gradient(from 90deg at 50% 50%, #ff7e7e 0deg, #ffc787 54.82deg, #fffc86 126.48deg, #85ff8d 203.65deg, #7cc6ff 272.33deg, #cd7cff 323.6deg, #ff8282 360deg);
  transition: box-shadow var(--transition);
  filter: contrast(1.2);
  opacity: 0.95;
}

.v-color-picker__icon:hover {
  box-shadow:
    inset 0 0 0 1px rgba(0, 0, 0, 0.1),
    0 0 4px 0px rgba(0, 0, 0, 0.4);
}

.v-color-picker__icon:active {
  box-shadow:
    inset 0 0 3px 1px rgba(0, 0, 0, 0.2),
    0 0 2px 0px rgba(0, 0, 0, 0.4);
}
</style>
